import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'store',
    loadChildren: () =>
      import('./modules/store-management/components/store/store.routes').then(
        (m) => m.routes
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/store-management/store-management.route').then(
        (m) => m.routes
      ),
  }
];
